var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteLongarrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 10,
    viewBox: "0 0 63 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.4734 5.06396C62.7156 4.8217 62.7156 4.42891 62.4734 4.18665L58.5255 0.238787C58.2833 -0.00347376 57.8905 -0.00347376 57.6482 0.238787C57.406 0.481048 57.406 0.87383 57.6482 1.11609L61.1574 4.62531L57.6482 8.13452C57.406 8.37678 57.406 8.76956 57.6482 9.01182C57.8905 9.25408 58.2833 9.25408 58.5255 9.01182L62.4734 5.06396ZM0 5.24565H62.0347V4.00496H0L0 5.24565Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLongarrow);
export default __webpack_public_path__ + "static/media/white-longarrow.e7ebabc80c4b604d441bd96f6c2b7e1f.svg";
export { ForwardRef as ReactComponent };